module.exports = __webpack_public_path__ + "content/e7dd5dee9b57c12683adc357fe8c456e.png";